import { gql } from '@apollo/client';
import eventAssignmentsFragment from './eventAssignmentsFragment';
import sowStatusesFragment from './sowStatusesFragment';

const REVIEW_EVENT = gql`
  mutation ReviewEvent($eventReview: EventReviewInput!) {
    reviewEvent(eventReview: $eventReview) {
      Id
      Stage
      EventAssignments {
        ...EventAssignmentsFields
      }
      SowStatuses {
        ...SowStatusesFields
      }
    }
  }

  ${eventAssignmentsFragment}
  ${sowStatusesFragment}
`;

export default REVIEW_EVENT;
